@import "node_modules/@glidejs/glide/src/assets/sass/glide.core";

app-carousel {
    .app-carousel {
        position: relative;

        .app-carousel-inner {
            position: relative;

            .glide__slides {
                white-space: normal;

                .app-carousel-card {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    position: relative;
                    @include margins(0,142,0,142);
                    @include padding-direction(top, 38);
                    height: 100%;
                    max-width: 792px;
                    background-color: white;

                    p.quote {
                        color: $gray-dark;
                        font-family: $font-family-primary;
                        font-weight: 400;
                        text-align: left;
                        @include text-size(20);
                        @include line-height(28);
                        font-style: normal;
                    }

                    .person-wrapper {
                        @include margin-direction(top, 47);
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-start;

                        img {
                            height: 64px;
                            width: 64px;
                            border-radius: 50%;
                            object-fit: cover;
                            @include margin-direction(right, 16);
                        }

                        .person-text-wrapper {
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-start;

                            h6 {
                                color: $gray-dark;
                                font-family: $font-family-primary-bold;
                                text-align: left;
                                @include text-size(24);
                                @include line-height(28);
                                margin-bottom: 0;
                            }

                            small {
                                display: inline-block;
                                color: $gray-dark;
                                font-style: oblique;
                                @include text-size(20);
                                @include line-height(20);
                            }
                        }
                    }

                }
            }

            .controls {

                button {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 80px;
                    height: 100%;
                    background: none;
                    // reset default btn style
                    border: none;
                    outline: none;
                    box-shadow: none;
                }

                .prev-btn {
                    right: auto;
                    left: 0;
                    transition: all .3s ease-out;

                    &:hover,
                    &:focus {
                        transform: translateY(-50%) translateX(-3px) !important;
                    }
                }

                .next-btn {
                    left: auto;
                    right: 0;
                    transition: all .3s ease-out;

                    &:hover,
                    &:focus {
                        transform: translateY(-50%) translateX(3px) !important;
                    }
                }

                &.end-arrows {

                    .prev-btn,
                    .next-btn {
                        height: 60px;
                        width: 60px;
                        border-radius: 50%;
                        top: 50%;
                        transform: translateY(-50%);
                        background: $primary;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        svg {
                            @include svg-format(10px, 16px, $gray-dark);
                        }

                        &:hover,
                        &:focus {
                            background: $gray-dark;

                            svg {
                                @include svg-format(10px, 16px, $white);
                            }
                        }
                    }
                }
            }
        }

        .bullets-wrapper {
            display: flex;
            align-items: center;

            .glide__bullets {
                display: flex;

                button {
                    @include margins(0,7,0,7);
                    padding: 0;
                    background: none;
                    border: none;

                    svg {
                        @include svg-format(8px, 8px, $tertiary);
                    }

                    &:hover,
                    &:focus {
                        transform: scale(1.5);
                    }

                    &.glide__bullet--active {
                        transform: scale(1.75);

                        svg {
                            @include svg-format(20px, 20px, $tertiary);
                        }
                    }
                }
            }

            &.internal {
                position: absolute;
                bottom: 10px;
                left: 50%;
                transform: translateX(-50%);
            }

            &.external {
                justify-content: center;
                @include margin-direction(top, 16);

                .glide__bullets button {
                    background: $gray-dark;
                }

                .pause-action {
                    width: 21px;
                    height: 18px;
                    position: absolute;
                    top: 0;
                    left: 136px; //margin left of app-carousel-card minus 4px to adjust for svh size/spacing
                    background-color: transparent;

                    svg {
                        @include svg-format(21px, 18px, $gray-dark);
                    }
                }
            }

            button {
                // reset default btn style
                border: none;
                outline: none;
                box-shadow: none;
                transition: all 350ms;
                width: 8px;
                height: 8px;
                border-radius: 50%;
            }
        }

        @include media-breakpoint-down(xl) {

            .app-carousel-inner {
    
                .glide__slides {
    
                    .app-carousel-card {
                        margin: 0;
                        max-width: none;
    
                        p.quote {
                            @include text-size(16);
                            @include line-height(24);
                        }
    
                        .person-wrapper {
                            @include margin-direction(top, 36);
    
                            img {
                                height: 48px;
                                width: 48px;
                            }
    
                            .person-text-wrapper {
    
                                h6 {
                                    @include text-size(20);
                                    @include line-height(24);
                                }
    
                                small {
                                    @include text-size(18);
                                    @include line-height(18);
                                }
                            }
                        }
    
                    }
                }
    
                .controls {
    
                    &.end-arrows {
    
                        .prev-btn,
                        .next-btn {
                            height: 44px;
                            width: 44px;
                            top: calc(100% + 60px);
                        }
                    }
                }
            }
    
            .bullets-wrapper {
    
                &.external {
                    justify-content: center;
                    @include margin-direction(top, 60);
    
                    .pause-action {
                        left: -4px;
                    }
                }
            }
        }
    }
}